import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { registerViewsKeys } from '../registerViewKeys'
import { PageResponse } from '@core/entities/pagination'
import {
  IRegisterView,
  RegisterView,
} from '@core/entities/register/RegisterView'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const viewsTransform = (response: PageResponse<IRegisterView>) => ({
  ...response,
  content: response.content.map((view) => RegisterView.new(view)),
})
export const useGetRegisterTemplateViews = (
  payload: RequestTypes['getRegisterTemplateViews'],
  options?: UseQueryOptions<
    PageResponse<IRegisterView>,
    RequestErrorType,
    PageResponse<RegisterView>
  >,
) => {
  return useQuery({
    select: viewsTransform,
    ...registerViewsKeys.list(payload),
    keepPreviousData: true,
    ...options,
  })
}
